// ANY ENV VARIABLE used in this file must be defined in webpack.config.js
import { appInstance, instance } from '@api/setup';
import { datadogRum } from '@datadog/browser-rum';
import { LicenseInfo } from '@mui/x-license-pro';
import { isProd } from '@utils/api';
import { IS_TEST_MODE } from 'constants/global';
import { noop } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import 'regenerator-runtime/runtime';
import { experiments, EXPERIMENTS_SESSION_KEY } from './experiments';

const DEPLOYMENT_MODES = {
	production: 'production',
	development: 'development'
};

LicenseInfo.setLicenseKey(
	'6d3b02faf2dc31b8cb71255aca38baf2Tz00NjEzMSxFPTE2ODc1MTk1MjQ3MTgsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

const DEV_BASE_URL = 'https://localhost:8443/console';
const getProdConsoleBaseUrl = () => process.env.PROD_CONSOLE_BASE_URL;
const getProdBaseUrl = () => process.env.PROD_API_BASE_URL;

const initBaseURL = () => {
	instance.defaults.baseURL =
		process.env.NODE_ENV === 'production'
			? getProdConsoleBaseUrl()
			: DEV_BASE_URL;

	appInstance.defaults.baseURL =
		process.env.NODE_ENV === 'production'
			? getProdBaseUrl()
			: 'https://localhost:8443';
};

const initAxe = () => {
	if (process.env.NODE_ENV !== DEPLOYMENT_MODES.production && !IS_TEST_MODE) {
		// eslint-disable-next-line import/no-extraneous-dependencies, global-require
		const axe = require('@axe-core/react');
		axe(React, ReactDOM, 1000, {
			rules: [
				{
					id: 'page-has-heading-one',
					enabled: false
				},
				{
					id: 'landmark-one-main',
					enabled: false
				},
				{
					id: 'region',
					enabled: false
				},
				{
					id: 'aria-valid-attr-value',
					enabled: false
				},
				{
					id: 'aria-required-children',
					enabled: false
				},
				{
					id: 'nested-interactive',
					enabled: false
				}
			]
		});
	}
};

// using segment only when APP_ENV is set as deployed in production.
const initAnalytics = () => {
	if (isProd()) {
		try {
			const s = document.createElement('script');

			s.type = 'text/javascript';
			s.innerText =
				'!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.s.descope.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="dxAoanXMbhwiyXYeaV4Lgcc4eWSeZxaz";;analytics.SNIPPET_VERSION="4.15.3";analytics.load("dxAoanXMbhwiyXYeaV4Lgcc4eWSeZxaz");analytics.page();}}();';
			document.getElementsByTagName('head')[0].appendChild(s);
		} catch (e) {
			console.log('failed to load segment', e); // eslint-disable-line
		}
	} else if (!global.analytics) {
		Object.defineProperty(global, 'analytics', {
			writable: false,
			value: {
				identify: noop,
				track: noop
			}
		});
	}
};

const initExperiments = () => {
	try {
		window.sessionStorage.setItem(
			EXPERIMENTS_SESSION_KEY,
			JSON.stringify(experiments)
		);
	} catch (e) {
		console.error('failed to load experiments', e); // eslint-disable-line
	}
};

const initDataDog = () => {
	if (!isProd()) {
		datadogRum.init({
			applicationId: '54ee770b-0675-4e45-aec9-f86bb4cfee3f',
			clientToken: 'pub2e072ab4e5ec5277e1d049894a0c85ca',
			site: 'datadoghq.com',
			service: 'console-descope.com',
			env: process.env.NODE_ENV,
			version: process.env.APP_VERSION,
			sampleRate: 100,
			premiumSampleRate: 100,
			defaultPrivacyLevel: 'mask-user-input',
			trackUserInteractions: true,
			trackFrustrations: true,
			trackResources: true,
			trackLongTasks: true
		});

		datadogRum.startSessionReplayRecording();
	}
};

export const initApp = () => {
	// ANY ENV VARIABLE used in this file must be defined in webpack.config.js
	initBaseURL();
	initAxe();
	initAnalytics();
	initExperiments();
	initDataDog();
};
